import { Link } from '@tanstack/react-router'
import { Logo } from '@/assets/logo'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '../ui/sidebar'

export function AppTopBar() {
  const { state, setOpenMobile } = useSidebar()
  const isCollapsed = state === 'collapsed'

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        {/* 品牌区点击回主页（探索发现 /）；asChild 让整块渲染为链接，移动端顺带收起侧栏 */}
        <SidebarMenuButton
          size='lg'
          className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground'
          asChild
        >
          <Link to='/' onClick={() => setOpenMobile(false)}>
            <div className='bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg'>
              <Logo className='size-lg' />
            </div>
            {!isCollapsed && (
              <div className='grid flex-1 text-start leading-relaxed'>
                <span className='truncate text-sm font-bold tracking-wider text-slate-900 dark:text-slate-100'>
                  元点引擎
                </span>
                <span className='truncate text-[11px] font-medium tracking-normal text-slate-500/80'>
                  创建你自己的世界
                </span>
              </div>
            )}
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
